// Store Splide instances
let splideInstances = [];

// Function to initialize all Splide sliders in the Tab
function initializeSplides() {
  const splideElements = document.querySelectorAll('.coll_tab_splide');

  splideElements.forEach((coll_splide, index) => {
    // Destroy existing Splide instance if it exists
    if (splideInstances[index]) {
      splideInstances[index].destroy(true);
    }

    // Initialize a new Splide instance
    const collSplide = new Splide(coll_splide, {
      type: "slide",
      pagination: true,
      gap: '1.9rem',
      focus: 0,
      perPage: 2.6,
      arrows: true,
      breakpoints: {
        576: {
          gap: '1rem',
          perPage: 2,
        },
        480: {
          perPage: 1,
        },
      },
    });

    collSplide.mount();
    splideInstances[index] = collSplide; // Store the instance
  });
}

// Initialize Splide on page load
initializeSplides();

// Featured Collection Tab functionality
const tabs = document.querySelectorAll('.tab__hdng');
const contents = document.querySelectorAll('.tab__cntnt');

tabs.forEach((tab, index) => {
  tab.addEventListener('click', () => {
    // Deactivate all tabs and contents
    document.querySelector('.tab__hdng.active')?.classList.remove('active');
    document.querySelector('.tab__cntnt.active')?.classList.remove('active');

    // Activate clicked tab and corresponding content
    tab.classList.add('active');
    contents[index].classList.add('active');

    // Reinitialize Splide for the active tab content
    initializeSplides();
  });
});

// Set the first tab as active initially
tabs[0].classList.add('active');
contents[0].classList.add('active');
